// #####################################################################
// nnDSPObject
// 1.0
// Copyright (2016) nanonum http://www.nanonum.com/
// #####################################################################
// var nnDSPObject = nnDSPObject || {};

var nnDSPObject = (function(){
  var TWOPI = 6.28318530717958647692528676655900576;
  var PI = 3.14159265358979323846264338327950288;
  var M_PI = PI;
  var InterpArray = ['none', 'linear', 'cosine', 'cubic', 'spline'];
  // #####################################################################
  // genlib
  /*******************************************************************************************************************
  Copyright (c) 2012 Cycling '74

  Permission is hereby granted, free of charge, to any person obtaining a copy of this software
  and associated documentation files (the "Software"), to deal in the Software without restriction,
  including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense,
  and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so,
  subject to the following conditions:

  The above copyright notice and this permission notice shall be included in all copies
  or substantial portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
  INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
  IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
  WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE
  OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
  *******************************************************************************************************************/
  var util = {
    // #####################################################################
    mtof: function(m){
      return 440 * Math.exp(.057762265 * (m - 69));
    },
    phasewrap: function(val) {
        var oneovertwopi = 1.0 / TWOPI;
        if (val >= TWOPI || val <= TWOPI) {
            var d = val * oneovertwopi;  //multiply faster
            d = d - ~~(d);
            val = d * TWOPI;
        }
        if (val > M_PI) val -= TWOPI;
        if (val < -M_PI) val += TWOPI;
        return val;
    },
    genlib_cosT8: function(r) {
        var t84 = 56;
        var t83 = 1680;
        var t82 = 20160;
        var t81 = 2.4801587302e-05;
        var t73 = 42;
        var t72 = 840;
        var t71 = 1.9841269841e-04;
        if(r < 0.785398163397448309615660845819875721 && r > -0.785398163397448309615660845819875721){
            var rr = r*r;
            return 1. - rr * t81 * (t82 - rr * (t83 - rr * (t84 - rr)));
        }
        else if(r > 0.){
            r -= 1.57079632679489661923132169163975144;
            var rr = r*r;
            return -r * (1. - t71 * rr * (t72 - rr * (t73 - rr)));
        }
        else{
            r += 1.57079632679489661923132169163975144;
            var rr = r*r;
            return r * (1. - t71 * rr * (t72 - rr * (t73 - rr)));
        }
    },
    clamp: function(x, minVal, maxVal){
      return Math.min(Math.max(x,minVal),maxVal);
    },
    clip: function(x, minVal, maxVal){
      return Math.min(Math.max(x,minVal),maxVal);
    },
    // ---------------------------------------------------------------------
    // Interpolation
    /*******************************************************************************************************************
    Copyright (c) 2012 Cycling '74

    Permission is hereby granted, free of charge, to any person obtaining a copy of this software
    and associated documentation files (the "Software"), to deal in the Software without restriction,
    including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense,
    and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so,
    subject to the following conditions:

    The above copyright notice and this permission notice shall be included in all copies
    or substantial portions of the Software.

    THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
    INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
    IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
    WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE
    OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
    *******************************************************************************************************************/
    // ---------------------------------------------------------------------
    linear_interp: function(a, x, y) {
        return x+a*(y-x);
    },
    cosine_interp: function(a, x, y) {
        var a2 = (1.0- genlib_cosT8(phasewrap(a*M_PI)) )/2.0;
        return(x*(1.-a2)+y*a2);
    },
    cubic_interp: function(a, w, x, y, z) {
        var a2 = a*a;
        var f0 = z - y - w + x;
        var f1 = w - x - f0;
        var f2 = y - w;
        var f3 = x;
        return(f0*a*a2 + f1*a2 + f2*a + f3);
    },
    // Breeuwsma catmull-rom spline interpolation
    spline_interp: function(a, w, x, y, z) {
        var a2 = a*a;
        var f0 = -0.5*w + 1.5*x - 1.5*y + 0.5*z;
        var f1 = w - 2.5*x + 2.0*y - 0.5*z;
        var f2 = -0.5*w + 0.5*y;
        return(f0*a*a2 + f1*a2 + f2*a + x);
    }
  }
  return {
    // #####################################################################
    // buffer
    // #####################################################################
    Buffer: (function(){
       function Buffer(type, dim, interp){
        var Interp = {'none': 0, 'linear': 1, 'cosine': 2, 'cubic': 3, 'spline': 4};
        if(typeof interp === 'number'){
          this.interp = interp;
        }else{
          this.interp = Interp[interp] || 0;
        }
        this.dim = dim || 32;
        this.type = type || 'double';
        this._writeIndex = 0;
        this._readIndex = 0;
        this.alloc(this.type, this.dim);
      }
      Buffer.prototype.report = function(){
        console.log('====')
        console.log('dim=', this.dim);
        console.log('buff=', this._buff);
        console.log('interp=', InterpArray[this.interp]);
      }
      Buffer.prototype.alloc = function(type, dim){
        this._buff = (function(){
          switch(type){
            // Float -------------------------------------------------
            case 'float32':
            return new Float32Array(dim);
            break;
            // Int -------------------------------------------------
            case 'Int':   case 'int32':   case 'i32':   case 'long':
            return new Int32Array(dim);
            break;
            case 'Int16':   case 'int16':   case 'i16':   case 'short':
            return new Int16Array(dim);
            break;
            case 'Int8':   case 'int8':   case 'i8':
            return new Int8Array(dim);
            break;
            // Unsigned -------------------------------------------------
            case 'uint32':   case 'Uint32':   case 'unsigned int':   case 'unsigned long':
            return new Uint32Array(dim);
            break;
            case 'uint16':   case 'Uint16':   case 'unsigned short':
            return new Uint16Array(dim);
            break;
            case 'uint8':   case 'Uint8':
            return new Uint8Array(dim);
            break;
            // Double default -------------------------------------------------
            case 'double':   case 'float64':
            default:
            return new Float64Array(dim);
            break;
          }
        }());
      }
      Buffer.prototype.interp = function(interp){
        this.interp = interp || this.interp;
        return InterpArray[this.interp];
      }
      Buffer.prototype.poke = function(index, input){
        this._buff[index] = input;
      }
      Buffer.prototype.peek = function(index){
        var a, w, x, y, z;
        switch (this.interp) {
          // linear
          case 1:
          a = index - ~~(index);
          x = this._buff[~~(index) % this.dim];
          y = this._buff[(~~(index) + 1) % this.dim];
          console.log('linear', a, x, y);
          return linear_interp(a, x, y);
          break;
          // cosine
          case 2:
          a = index - ~~(index);
          x = this._buff[~~(index) % this.dim];
          y = this._buff[(~~(index) + 1) % this.dim];
          return util.cosine_interp(a, x, y);
          break;
          // cubic
          case 3:
          a = index - ~~(index);
          w = this._buff[~~(index) % this.dim];
          x = this._buff[(~~(index) + 1) % this.dim];
          y = this._buff[(~~(index) + 2) % this.dim];
          z = this._buff[(~~(index) + 3) % this.dim];
          return util.cubic_interp(a, w, x, y, z);
          break;
          // spline
          case 4:
          a = index - ~~(index);
          w = this._buff[~~(index) % this.dim];
          x = this._buff[(~~(index) + 1) % this.dim];
          y = this._buff[(~~(index) + 2) % this.dim];
          z = this._buff[(~~(index) + 3) % this.dim];

          return util.spline_interp(a, w, x, y, z);
          // none
          default:
          return this._buff[~~(index) % this.dim];
          break;
        }
        return 0;
      }
      Buffer.prototype.fillSin = function(max){
        var _max = max || 1;
        for (var i = 0; i < this.dim; i++) {
          var sined = ~~((Math.sin((i / this.dim) * TWOPI) + 1) * 50);
          this.poke(i, Math.sin((i / this.dim) * TWOPI) * _max);
        }
      }
      return Buffer;
    }()),

    // #####################################################################
    // Delay
    // #####################################################################
    Delay: (function(){
      function Delay(type, size, interp){
        var INTERP = {'none': 0, 'linear': 1, 'cosine': 2, 'cubic': 3, 'spline': 4};
        if(typeof interp === 'number'){
          this.interp = interp;
        }else{
          this.interp = INTERP[interp] || 0;
        }
        this.size = size || 32;
        this.type = type || 'double';
        this.writeIndex = 0;
        this.reset(this.type, this.size, this.interp);
      }
      Delay.prototype.reset = function(type, size, interp){
        this.buff = new nnDSPObject.Buffer(type, size, interp);
      }
      Delay.prototype.write = function(inputToDelay, doStep){
        this.buff.poke(this.writeIndex, inputToDelay);
        if(doStep){
          this.step();
        }
      }
      Delay.prototype.read = function(delayTimeOfSamples){
        var readPoint = this.writeIndex - delayTimeOfSamples;
        while (readPoint < 0) {
          readPoint += this.size;
        }
        var read = this.buff.peek(readPoint % this.size);
        return read;
      }
      Delay.prototype.lookup = function(readIndex){
        return this.buff.peek(readIndex % this.size);
      }
      Delay.prototype.step = function(buffersize){
        this.writeIndex++;
        while (this.writeIndex >= this.size) {
          this.writeIndex -= this.size;
        }
      }
      return Delay;
    }()),


    // #####################################################################
    // Comb
    // #####################################################################
    Comb: (function(){
      function Comb(size, interp){
        var _size = size || 32;
        this.history = 0;
        this.delay = new nnDSPObject.Delay(_size, interp);
      }
      Comb.prototype.comb = function(input, damp, fb, delaytime){
        var damp_cliped = util.clip(damp, 0, 1);
        var delayed = this.delay.read(delaytime);
        var result = delayed * damp_cliped + this.history * (1 - damp_cliped);
        this.delay.write(input + result * fb, true);
        this.history = input;
        return delayed;
      }
      Comb.prototype.help = function(){
        console.log('input, damp, fb, delaytime')
      }
      Comb.prototype.reset = function(){
        this.history = 0;
        this.delay.reset();
      }
      return Comb;
    }()),

    // #####################################################################
    // Decay
    // #####################################################################
    Decay: (function(){
      var EXP_LOW = 0.000001;
      function Decay(option){
        var defaults = {
          active: 0,
          count: 0,
          exp: 1
        }
        _.extend(defaults, option);
        this.active = defaults.active;
        this.count = defaults.count;
        this.exp = defaults.exp;
      }
      Decay.prototype.trigger = function(){
        this.active = 1;
        this.count = 0;
      }
      Decay.prototype.setCurve = function(exp){
        this.exp = Math.max(exp, EXP_LOW);
      }
      Decay.prototype.decay = function(decay, reset){
        if (reset) {
          this.active = 1;
          this.count = 0;
        }
        if(this.active){
          var env = 0;
          if (this.exp != 1) {
            env = Math.pow( (decay - this.count) / decay, this.exp);
          }else{
            env =  (decay - this.count) / decay;
          }
          if (this.count >= decay) {
            this.active = 0;
            return 0;
          }

          this.count++;
          return env;
        }else{
          return 0;
        }
      }
      return Decay;
    }()),


    // #####################################################################
    // Accelerator
    // #####################################################################
    Accelerator: (function(){
      function Accelerator(option){
        var defaults = {
          threshold: 1,
          friction: 0.95
        }
        _.extend(defaults, option);
        this.threshold = defaults.threshold;
        this.friction = defaults.friction;
        this.velocity = 0;
      }
      function _duck(value, threshold){
        return Math.abs(value) < threshold ? 0 : value;
      }
      Accelerator.prototype.update = function(value){
        var dir = Math.sign(value);
        this.velocity = _duck(this.velocity * this.friction + dir, this.threshold);
        return this.velocity;
      }
      Accelerator.prototype.get = function(){
        return this.velocity;
      }
      return Accelerator;
    }()),
    // #####################################################################
    // Z-1
    // #####################################################################
    Z: (function(){
      function Z(def){
        this.z = def || 0;
      }
      Z.prototype.update = function(value){
        var _z = this.z;
        this.z = value;
        return _z;
      }
      Z.prototype.get = function(){
        return this.z;
      }
      Z.prototype.reset = function(){
        this.z = 0;
      }
      return Z;
    }()),

    // #####################################################################
    // Low Pass Filter
    // #####################################################################
    LPF: (function(){
      function LPF(option){
        if(typeof option === 'number'){
          this.cutoff = option;
        }else{
          var defaults = {
            cutoff: 1,
          }
          _.extend(defaults, option);
          this.cutoff = defaults.cutoff;
        }
        this.z = new nnDSPObject.Z(0);

      }
      LPF.prototype.filter = function(input){
        var _z = this.z.get();
        var result = this.cutoff * input + (1.0 -  this.cutoff) * _z;
        this.z.update(result);
        return result;
      }
      LPF.prototype.setCutoff = function(cutoff){
        var min = Math.min(cutoff, 1.0);
        var max = Math.max(min, 0);
        this.cutoff = max;
      }
      LPF.prototype.reset = function(){
        this.z.reset();
      }
      return LPF;
    }()),

    // #####################################################################
    // Low Pass Filter
    // #####################################################################
    HPF: (function(){
      function HPF(option){
        if(typeof option === 'number'){
          this.cutoff = option;
        }else{
          var defaults = {
            cutoff: 1,
          }
          _.extend(defaults, option);
          this.cutoff = defaults.cutoff;
        }
        this.LPF = new nnDSPObject.LPF({cutoff: this.cutoff});
      }
      HPF.prototype.filter = function(input){
        var _lpf = this.LPF.filter(input);
        var result = input - _lpf;
        if(Math.abs(result) < 0.01){
          return 0;
        }else{
          return result;
        }
      }
      HPF.prototype.setCutoff = function(cutoff){
        this.LPF.setCutoff(cutoff);
      }
      HPF.prototype.reset = function(){
        this.LPF.reset();
      }
      return HPF;
    }()),

    // #####################################################################
    // LP2HP
    // #####################################################################
    LP2HP: (function(){
      function LP2HP(option){
        var defaults = {
          lpf: 1,
          hpf: 0
        }
        _.extend(defaults, option);

        // console.log(defaults)

        // this.cutoff.hpf = defaults.hpf;

        this.lp = new nnDSPObject.LPF(defaults.lpf);
        this.hp = new nnDSPObject.HPF(defaults.hpf);
        // this.LPF = new nnDSPObject.LPF({cutoff: this.cutoff});
        // this.LPF = new nnDSPObject.LPF({cutoff: this.cutoff});
      }
      LP2HP.prototype.filter = function(input){
        var output_lp = this.lp.filter(input);
        var output_hp = this.hp.filter(output_lp);
        return output_hp;
      }
      LP2HP.prototype.setCutoff = function(c_lp, c_hp){
        this.lp.setCutoff(c_lp);
        this.hp.setCutoff(c_hp);
      }
      LP2HP.prototype.reset = function(){
        this.lp.reset();
        this.hp.reset();
      }
      return LP2HP;
    }()),

    // #####################################################################
    Sah: (function(){
      function Sah(){
        this.value = .5;
      }
      Sah.prototype.bang = function(){
        if(Math.random() < 0.005){
          this.value = Math.random() + 0.2;
        }
        return this.value;
      }
      return Sah;
    }()),




    // #####################################################################
    // Impluse
    // #####################################################################
    Impluse:  (function(){
      function Impluse(amp){
        this.state = 0;
        this.amp = amp || 1;
      }
      Impluse.prototype.get = function(){
        if(!this.state){
          return 0;
        }else{
          var value = this.state;
          this.state = 0;
          return value * this.amp * (Math.random() - 0.5);
        }
      }
      Impluse.prototype.bang = function(){
        this.state = 1;
      }
      return Impluse;
    }())


  }
}());


module.exports = nnDSPObject;
